import React from "react"
import { Link } from "gatsby"
import { useTranslation } from "gatsby-plugin-react-i18next"
import { useSiteMetadata } from "@hooks/siteURLs"

const SiteLink = ({ url, text, className, multilanguage = true }) => {
  const { t } = useTranslation()
  const { url: internalSiteUrl } = useSiteMetadata(url, multilanguage)
  const isExternalLink = url && url.startsWith("http")

  const linkClassName =
    "text-[#3759f0] font-inter text-16 desk:text-20 font-normal leading-150%"

  return (
    <li className={className}>
      {isExternalLink ? (
        <a className={linkClassName} href={url} target="_blank">
          {t(text)}
        </a>
      ) : (
        <Link className={linkClassName} to={internalSiteUrl}>
          {t(text)}
        </Link>
      )}
    </li>
  )
}
const SiteMapLink = ({ title, links, className, multilanguage = true }) => {
  const { t } = useTranslation()

  return (
    <div className={className}>
      <p className="text-dblue font-inter text-20 desk:text-24 font-medium leading-150% mb-1 desk:mb-3 opacity-90">
        {t(title)}
      </p>
      <ul className="grid grid-cols-1 gap-2">
        {links?.map(link => (
          <SiteLink key={link.text} {...link} multilanguage={multilanguage} />
        ))}
      </ul>
    </div>
  )
}

export default SiteMapLink
